import { Component } from '@angular/core';

@Component({
    selector   : 'fuse-sample',
    templateUrl: './sample.component.html',
    styleUrls  : ['./sample.component.scss']
})
export class FuseSampleComponent
{
    constructor()
    {
    	console.log('LO QUE ENCUENTRA DESDE SAMPLE: ',sessionStorage.getItem('token'));
    }
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/sample/sample.component.ts